import React from 'react'
import { DialogActions } from '@mui/material';
import PrimaryButton from '../button/PrimaryButton';
import SecondaryButton from '../button/SecondaryButton';

const DialogFooter = (props) => {
  return (
    <DialogActions className='dialog-footer justify-between mt-3'>
      {props.customFooter ?
        props.customFooter
        :
        (
          <React.Fragment>
            <SecondaryButton
              id='dialog-secondary-btn'
              text={props.secondaryButton.text}
              onClick={props.onClose}
              isDisabled={props.secondaryButton.isDisabled}
              className={props.secondaryButton.className}
            />
            <PrimaryButton
              id='dialog-primary-btn'
              text={props.primaryButton.text}
              onClick={props.onSubmit}
              isDisabled={props.primaryButton.isDisabled}
              className={props.primaryButton.className}
            />
          </React.Fragment>
        )}
    </DialogActions>
  )
}

export default DialogFooter;
